import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => {
  return {
    textAreaDescriptionWrapper: {
      width: "100%",
      position: "sticky"
    },
    headerContainer: {
      padding: "0px 20px",
      alignItems: "center"
    },
    divider: {
      borderBottom: "1px solid #e1e8ee",
      margin: "15px 0"
    },
    verticalDivider: {
      display: "inline-block",
      width: "1px",
      backgroundColor: "#b9bcd1",
      margin: "0 10px",
      height: "36px"
    },
    subjectLabel: {
      opacity: "0.5",
      marginRight: "10px"
    },
    docContainer: {
      padding: "20px 20px 0 20px"
    },
    docRow: {
      marginBottom: "10px",
      padding: "10px 15px",
      borderRadius: "6px",
      height: "56px",
      backgroundColor: "#f7f7f7",
      alignItems: "center"
    },
    chipContainer: {
      cursor: "pointer",
      display: "inline-flex",
      padding: "7px",
      borderRadius: "25px",
      color: "#535b91",
      background: theme?.defaultUserTheme?.primaryChipColor
    },
    missingChipContainer: {
      cursor: "pointer",
      display: "inline-flex",
      padding: "7px",
      borderRadius: "25px",
      color: "#82211d",
      background: "rgba(255, 54, 46, 0.08)"
    }
  };
});
